module.exports = __webpack_public_path__ + "img/xmgj.740b2993.png";